
export default function anonymizeEmail(email: string): string {
    const [username, domain] = email.split('@');
    return `${username.slice(0, 2)}*****${username[username.length-1]}@${domain}`;
}
